import { compose, configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';

export const store = configureStore(
  {
    reducer: rootReducer
  },
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
);
